module.exports = __webpack_public_path__ + "img/emo_22.5087672c.png";